import api from '..'

const requests = {
    check: async () => {
        try {
            var response = await api.get('/maarima/healthCheck')
            if (response.status >= 400) {
                return false
            }
            return true
        } catch (err) {
            return false
        }
    }
}
export default requests
